import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  UnityGameSkill,
  UnityGameSuccesful,
  UnityGameYears,
  UnityGameClients,
} from "../../../app-constants-updated";

function Ratingunity() {
  return (
    <section className="rating_unity p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              TekRevol: A Powerhouse of <span>Innovation</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="rating-num-main">
              <div className="rating-item">
                <div className="rating-flex">
                  <div className="rating-unity-icon">{UnityGameSkill}</div>
                  <div className="rating-unity-content">
                    <h4 style={{ color: "#0B314D" }}>400+</h4>
                    <p style={{ color: "#0B314D" }}>skilled professionals</p>
                  </div>
                </div>
              </div>
              <div className="rating-item">
                <div className="rating-flex">
                  <div className="rating-unity-icon">{UnityGameSuccesful}</div>
                  <div className="rating-unity-content">
                    <h4 style={{ color: "#0B314D" }}>500+</h4>
                    <p style={{ color: "#0B314D" }}>
                      successful app and game launches
                    </p>
                  </div>
                </div>
              </div>
              <div className="rating-item">
                <div className="rating-flex">
                  <div className="rating-unity-icon">{UnityGameYears}</div>
                  <div className="rating-unity-content">
                    <h4 style={{ color: "#0B314D" }}>8+</h4>
                    <p style={{ color: "#0B314D" }}>
                      years of industry experience
                    </p>
                  </div>
                </div>
              </div>
              <div className="rating-item">
                <div className="rating-flex">
                  <div className="rating-unity-icon">{UnityGameClients}</div>
                  <div className="rating-unity-content">
                    <h4 style={{ color: "#0B314D" }}>250+</h4>
                    <p style={{ color: "#0B314D" }}>
                      satisfied clients worldwide
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ratingunity;
